import React from 'react'
import ReactDOMServer from 'react-dom/server'
import { Trans } from 'react-i18next'

import { store } from 'store/reducers'
import { getUserName } from 'services/Utilities'
import { Format } from 'services/Dates'
import { t } from 'translations'
import hasAccessToThis from 'services/utilFunctions/hasAccessToThis'
import { HideOverflow } from 'components/UI'

const getTimeOffBubbleHtml = ({ userId, sce = [], comments }) => {
  const {
    settings: { defaultTimeZone: timeZone }
  } = store.getState()

  let lastConfirmationInfo

  // Confirmation status
  const lastConfirmation = [...sce].shift()

  if (typeof lastConfirmation === 'object' && lastConfirmation.type !== 'cancellation' && hasAccessToThis('scheduleConfirm')) {
    let lastConfirmationKey
    switch (lastConfirmation.method) {
      case 'email':
        if (lastConfirmation.events.confirmed) lastConfirmationKey = 'confirmed'
        else if (lastConfirmation.events.opened) lastConfirmationKey = 'opened'
        else if (lastConfirmation.events.delivered) lastConfirmationKey = 'delivered'
        else if (lastConfirmation.events.failed) lastConfirmationKey = 'failed'
        else if (lastConfirmation.events.accepted) lastConfirmationKey = 'accepted'
        break
      case 'phone':
        if (lastConfirmation.events.noPhone) lastConfirmationKey = 'noPhone'
        else if (lastConfirmation.events.failed) lastConfirmationKey = 'failed'
        else if (lastConfirmation.events.confirmed) lastConfirmationKey = 'confirmed'
        break
      default:
        break
    }

    if (lastConfirmationKey)
      lastConfirmationInfo = {
        method: lastConfirmation.method,
        date: lastConfirmation.events[lastConfirmationKey],
        eventKey: lastConfirmationKey,
        confirmedBy: lastConfirmation.confirmedBy
      }
  }

  // Daypilot does not support jsx except in specific cases and it is cleaner and less error prone to use jsx than build an html string manually.
  return ReactDOMServer.renderToString(
    <>
      <div>
        <div>
          <b>{getUserName(userId, { showEmployeeNumber: true })}</b>
        </div>

        {comments?.length > 0
          ? comments.map((comment, index) => (
              <div key={index} className="font-italic">
                <i className="fas fa-comment" />
                <HideOverflow parsedValues={comment.split('')} hideOverflow={100} delimiter={''} hideButton />
              </div>
            ))
          : null}
      </div>

      {/* Confirmation info */}
      {lastConfirmationInfo && hasAccessToThis('scheduleConfirm') ? (
        <div
          className={
            { confirmed: 'text-success', opened: 'text-success', delivered: 'text-success', failed: 'text-danger', noPhone: 'text-danger' }[
              lastConfirmationInfo.eventKey
            ]
          }
        >
          <i className={`fa ${{ email: 'fa-envelope', phone: 'fa-phone' }[lastConfirmationInfo.method]} mr-1`}></i>
          <Trans
            t={t}
            i18nKey={`manager.schedule.EDIT_MODAL.CONFIRMATION_EVENTS.${lastConfirmationInfo.eventKey.toUpperCase()}_${lastConfirmationInfo.method.toUpperCase()}`}
          >
            <b>{{ name: getUserName(lastConfirmationInfo.confirmedBy) }}</b>
            <b>{{ time: Format(lastConfirmationInfo.date, { outFormat: 'time', isUTC: true, timeZone }) }}</b>
            {{ date: Format(lastConfirmationInfo.date, { outFormat: 'humanDate', isUTC: true, timeZone }) }}
          </Trans>
        </div>
      ) : null}
    </>
  )
}

export default getTimeOffBubbleHtml
